import { pdfjs } from "react-pdf"

// CRA (webpack 5) can't easily bundle the pdfjs worker via import.meta.url,
// so load the version-matched worker from a CDN. Import this module once
// before rendering any react-pdf <Document>.
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

export { pdfjs }
